// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"166":"1d44cacd","266":"91ab77bf","294":"60351eb5","938":"c5e3cf9d"}[chunkId] + ".css";
};